<template>
    <base-layout>
        <!-- 组件 -->
        <download-bar/>
        <!-- START -->
        <div class="section banner">
            <!-- 返回按钮 -->
            <a class="btn btn-back" :href="backLink">
                <i class="iconfont icon-back"></i>
            </a>
        </div>
        <!-- 文章详情 -->
        <div class="section article">
            <div class="section-title">
                <i class="iconfont icon-list"></i> {{ title }}
            </div>
            <div class="section-content" v-html="content"></div>
        </div>
        <site-footer/>        
    </base-layout>
</template>

<script>

import { params, timeFormat } from '~/js/utils'

export default {
    name: 'ArticleMobile',
    data () {
        return {
            title: '',
            content: '',
            backLink: '/news.html'
        }
    },
    components: {
        SiteFooter: () => import('components/SiteFooter'),
        DownloadBar: () => import('components/DownloadBar'),
    },
       mounted () {
        if(params.id) {

            this.$loading.show()
            
            // 请求文章
            $.get($.path.getArticleContent, {
                    aid: params.id,
                    gameid: this.g.gameid
                }).then(d => {
                
                // 隐藏loading
                this.$loading.hide()

                let { code, data, msg } = d
                if (code == 100) {
                    if(data instanceof Array && data.length) {
                        data = data[0]
                    }

                    this.title = data.title
                    this.content = data.content.replace(/&nbsp;/g, ' ')

                    // 返回按钮修正链接
                    this.backLink = `./news.html?tab=${data.level}`

                }else {
                    this.$message(err || this.$t('request_error'), {
                        showClose: true
                    })
                }

            }).catch(err => {
                this.$message(err || this.$t('request_error'), {
                    showClose: true
                })
            })
        }
    },
    beforeCreate () {
        if(!params.id) {
            this.$message(this.$t('require_argument'),{
                showClose: true,
                btns: [
                    {
                        type: 'error',
                        text: this.$t('confirm'),
                        callback () {
                            location.href = '/news.html'
                        }
                    }
                ]

            });
        }
    }
}
</script>

<style lang="scss" src="~/scss/mobile.scss"></style>
<style lang="scss">
    /*文章样式*/
    .article {
        padding-bottom: 0.34rem;
        font-size: 0.24rem;
        img {
            max-width: 100%;
        }
        .section-title {
            height: auto;
            white-space: unset
        }
        .section-content {
            line-height: normal;
            white-space: normal;
            word-break: break-word;
            td {
                vertical-align: middle;
            }
        }
    }
</style>